import { render, staticRenderFns } from "./PosPromotionCreate.vue?vue&type=template&id=48dde6da&scoped=true&"
import script from "./PosPromotionCreate.vue?vue&type=script&lang=js&"
export * from "./PosPromotionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dde6da",
  null
  
)

export default component.exports